import { PropsWithChildren, ReactNode } from "react";
import { Link } from "react-router-dom";

import { useApplication } from "@ryde/redux";
import {
  AppNavigateRoutes,
  RoutesAdmin,
  usePrefixedRouting,
} from "@ryde/shared";

import { LeftBarLiStyled } from "./left-bar.styled";
import { NavButtonTooltipWrapper } from "./left-bar.tooltip";

interface ISideBarLinkProps extends PropsWithChildren {
  to: AppNavigateRoutes | RoutesAdmin;
  queryParams?: string;
  tooltip: string;
}

export const SideBarLink = ({
  children,
  to,
  queryParams,
  tooltip,
}: ISideBarLinkProps): ReactNode => {
  const { isAdminApp } = useApplication();
  const { addPrefix } = usePrefixedRouting();
  return (
    <LeftBarLiStyled $isAdminApp={isAdminApp}>
      <NavButtonTooltipWrapper tooltip={tooltip}>
        <Link to={addPrefix(`${to}${queryParams ?? ""}`)}>{children}</Link>
      </NavButtonTooltipWrapper>
    </LeftBarLiStyled>
  );
};
